import { Heart } from "lucide-react";
import { Reveal } from "./Reveal";
import { Divider, Eucalyptus } from "./Botanical";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative px-4 sm:px-8 lg:px-12 pt-16 sm:pt-20 pb-12 overflow-x-clip"
    >
      <div
        dir="ltr"
        className="pointer-events-none select-none absolute inset-x-0 -bottom-2 text-center font-display uppercase text-[calc(0.066*var(--cw))] leading-none text-[#1A1612]/[0.05] whitespace-nowrap"
      >
        Parmiss &amp; Samie
      </div>
      <Eucalyptus className="pointer-events-none absolute top-4 -right-6 w-[clamp(calc(9rem*var(--bmin)),calc(0.14*var(--cw)),13rem)] opacity-70 rotate-180" />
      <Eucalyptus className="pointer-events-none absolute top-4 -left-6 w-[clamp(calc(9rem*var(--bmin)),calc(0.14*var(--cw)),13rem)] opacity-70 -scale-x-100 rotate-180" />

      <div className="relative max-w-6xl mx-auto text-center">
        <Reveal>
          <Divider className="w-56 sm:w-72 mx-auto mb-10 opacity-90" />
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="h-px w-16 bg-[#E6DEC8]" />
            <Heart size={18} className="text-[#C29B38]" fill="currentColor" />
            <span className="h-px w-16 bg-[#E6DEC8]" />
          </div>
          <p dir="ltr" className="font-display text-4xl sm:text-5xl text-[#1A1612] mb-3">
            Parmiss <span className="text-[#C29B38]">&amp;</span> Samie
          </p>
          <p className="text-sm text-[#8C827A]">۱۲ مهر ۱۴۰۵ · باغ تماشا</p>

          <p className="text-xs text-[#8C827A]/70 mt-14">با عشق ساخته شده، برای مهمانان عزیزمان</p>
        </Reveal>
      </div>
    </footer>
  );
};
